export default (error) => {
  if (!error.response) {
    return Promise.reject('网络连接超时');
  };

  let tip = '';
  const status = error.response.status;

  switch (status) {
    case 400:
        tip = '错误的请求参数';
        break;
    case 401:
        tip = '没有该操作权限';
        break;
    case 403:
        tip = '请登录';
        break;
    case 404:
        tip = '错误的请求地址';
        break;
    case 500:
    case 501:
    case 502:
    case 503:
    case 504:
        tip = '服务器错误';
        break;
    default:
        tip = '未知错误' + status;
  }
  return Promise.reject(tip);
}



// WEBPACK FOOTER //
// ./src/assets/utils/httpErrorHandler.js